import { styled } from "@linaria/react";
import RhombusButton from "components/common/RhombusButton";
import {
  CTA_BUTTON_COPY_7,
  LIVE_DEMO_LINK,
} from "components/data/landing-page-data";
import PageSection from "components/rui/page-components/PageSection";
import { Body, TitleSmall } from "components/rui/typography";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import IconAi from "../icon-components/IconAi";
import IconAutomatic from "../icon-components/IconAutomatic";
import IconSecurity from "../icon-components/IconSecurity";
import IconEvolve from "../icon-components/IconEvolve";
import { css } from "@linaria/core";

const BREAK_POINT = "1130px";

const ContentWrapper = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  @media (max-width: ${BREAK_POINT}) {
    flex-direction: column;
    align-items: unset;
  }
`;

const SpecList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const SpecRow = styled.div`
  display: flex;
  gap: 20px;
  max-width: 640px;
  > :first-child {
    flex-shrink: 0;
  }
  h4 {
    margin-bottom: 8px;
  }
`;

const imageStyles = css`
  width: 640px;
  height: 544px;
  flex-shrink: 0;
  @media (max-width: ${BREAK_POINT}) {
    height: auto;
    width: auto;
    max-width: 640px;
  }
`;

const SPECS = [
  {
    icon: <IconAi />,
    title: "Proactive Security, Powered by AI",
    description:
      "Protect spaces 24/7 and respond rapidly with intelligent monitoring that detects threats and sends real-time alerts.",
  },
  {
    icon: <IconAutomatic />,
    title: "Quick and Automatic Threat Deterrence",
    description:
      "Trigger audio and visual deterrence automatically based on advanced AI detections.",
  },
  {
    icon: <IconSecurity />,
    title: "Security on Your Terms",
    description:
      "Easily customize alerts and rules to suit your operation. From healthcare to corporate offices, you're always in control.",
  },
  {
    icon: <IconEvolve />,
    title: "Smarter Over Time",
    description:
      "The system learns and adapts, delivering sharper alerts as your needs evolve.",
  },
];

const AiSpecs = () => {
  return (
    <PageSection
      bgColor="var(--neutral-100)"
      title={"Stay Ahead with Real Time Video Analytics and Detections"}
    >
      <ContentWrapper>
        <StaticImage
          loading="lazy"
          objectFit="contain"
          className={imageStyles}
          src="../assets/mobile-alerts-min.png"
          alt="license plate recognition with ai powered video analytics"
        />
        <SpecList>
          {SPECS.map((s) => (
            <SpecRow>
              {s.icon}
              <div>
                <TitleSmall>{s.title}</TitleSmall>
                <Body>{s.description}</Body>
              </div>
            </SpecRow>
          ))}
        </SpecList>
      </ContentWrapper>
      <RhombusButton
        title={CTA_BUTTON_COPY_7}
        path={LIVE_DEMO_LINK}
        type="primary-dark"
      />
    </PageSection>
  );
};

export default AiSpecs;
